var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('strong',[_vm._v(_vm._s(this.nameWithCommaIfDescription))]),_vm._v("\n  "+_vm._s(this.item.description)+" "+_vm._s(_vm.price)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }